import React, {
  useState,
} from "react";

import {
  Stack,
  Select,
  Text,
  NumberInput,
  NumberInputField,
} from "@chakra-ui/react";

import ReusableDrawer from "components/Drawers/ReusableDrawer";
import ReusableInput from "components/Inputs/ReusableInput";
import GradientButton from "components/Buttons/GradientButton";

const AddAgentTraining = ({
  isOpen,
  onClose,
  onAddTraining,
}) => {

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    content: "",
    video_url: "",
    material_url: "",
    display_order: 0,
    mandatory: true,
  });


  const handleInputChange = (e) => {

    const {
      name,
      value,
    } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

  };


  const handleSubmit = async () => {

    if (!formData.title.trim()) {

      alert(
        "Please enter a training title."
      );

      return;
    }


    const payload = {
      title: formData.title,
      description: formData.description,
      content: formData.content,
      video_url: formData.video_url,
      material_url: formData.material_url,
      display_order: Number(
        formData.display_order
      ),
      mandatory: formData.mandatory,
    };


    try {

      const response =
        await onAddTraining(
          payload
        );


      if (response?.success) {

        setFormData({
          title: "",
          description: "",
          content: "",
          video_url: "",
          material_url: "",
          display_order: 0,
          mandatory: true,
        });

        onClose();

      }

    } catch (error) {

      console.error(
        "Error creating training:",
        error
      );

    }

  };


  return (

    <ReusableDrawer

      isOpen={isOpen}

      onClose={onClose}

      headerContent={
        <h2>
          Add Agent Training
        </h2>
      }

      bodyContent={

        <Stack spacing={4}>

          <ReusableInput
            label="Title"
            name="title"
            value={
              formData.title
            }
            onChange={
              handleInputChange
            }
            placeholder="Enter training title"
            isRequired
          />


          <ReusableInput
            label="Description"
            name="description"
            value={
              formData.description
            }
            onChange={
              handleInputChange
            }
            placeholder="Enter training description"
            type="textarea"
          />


          <ReusableInput
            label="Content"
            name="content"
            value={
              formData.content
            }
            onChange={
              handleInputChange
            }
            placeholder="Enter training content"
            type="textarea"
          />


          <ReusableInput
            label="Video URL"
            name="video_url"
            value={
              formData.video_url
            }
            onChange={
              handleInputChange
            }
            placeholder="Enter video URL"
          />


          <ReusableInput
            label="Material URL"
            name="material_url"
            value={
              formData.material_url
            }
            onChange={
              handleInputChange
            }
            placeholder="Enter material URL"
          />


          <Stack spacing={2}>

            <Text
              fontSize="sm"
              color="gray.500"
            >
              Display Order
            </Text>

            <NumberInput
              min={0}
              value={
                formData.display_order
              }
              onChange={(value) =>
                setFormData(
                  (prev) => ({
                    ...prev,
                    display_order:
                      value,
                  })
                )
              }
            >

              <NumberInputField />

            </NumberInput>

          </Stack>


          <Stack spacing={2}>

            <Text
              fontSize="sm"
              color="gray.500"
            >
              Mandatory
            </Text>

            <Select
              value={
                String(
                  formData.mandatory
                )
              }
              onChange={(e) =>
                setFormData(
                  (prev) => ({
                    ...prev,
                    mandatory:
                      e.target.value ===
                      "true",
                  })
                )
              }
            >

              <option value="true">
                Yes
              </option>

              <option value="false">
                No
              </option>

            </Select>

          </Stack>

        </Stack>
      }

      footerContent={

        <Stack
          direction="row"
          spacing={4}
          justifyContent="flex-end"
        >

          <GradientButton
            width="100px"
            height="40px"
            onClick={onClose}
          >
            Cancel
          </GradientButton>


          <GradientButton
            width="100px"
            height="40px"
            onClick={handleSubmit}
          >
            Save
          </GradientButton>

        </Stack>

      }

    />

  );

};


export default AddAgentTraining;